import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
  import Accordion from '@/bps/components/accordion/accordion.vue';
  import {type AccordionProps} from '@/bps/components/accordion/accordion.vue';
  import {useIsMobile, type Breakpoint} from '@/bps/utilities/composables/isMobile/isMobile';

  interface AccordionMobileProps {
    mobileBreakpoint?: Breakpoint;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'accordionMobile',
  props: {
    initialOpen: { type: Boolean, default: false },
    foldOut: { type: Boolean, default: false },
    useMaxHeight: { type: Boolean, default: true },
    anchor: { default: null },
    mobileBreakpoint: { default: 768 }
  },
  setup(__props: any) {

  const props = __props;

  const {isMobile} = useIsMobile(props.mobileBreakpoint);

  const childProps = computed<AccordionProps>(() => {
    return {
      initialOpen: isMobile.value ? props.initialOpen : true,
      foldOut: isMobile.value ? props.foldOut : true,
      useMaxHeight: props.useMaxHeight,
      anchor: props.anchor
    };
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Accordion, _mergeProps({ class: "accordion-mobile" }, childProps.value), {
    head: _withCtx(() => [
      _renderSlot(_ctx.$slots, "head")
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}
}

})